import type { Options } from "../interface.ts";

/** SVGPathCommander default options */
export const defaultOptions: Options = {
  origin: [0, 0, 0],
  round: 4,
};
